<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- App main page -->
<template>
  <div id="app">
    <nav-header class="application-header"></nav-header>
    <div class="content">
      <!-- <router-view/> -->
      <router-view v-slot="{ Component }">
        <transition name="slide" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
    <av-modal :visible="showExpirationWarning" :canCloseSelf="false">
      <div class="modal-content">Due to inactivity, you will be logged out in {{ timeToSessionExpiration  }} seconds. Do you want to stay logged in?</div>
      <div class="modal-actions">
        <av-button class="error hollow" @click="logOut">No, Log Me Out</av-button>
        <av-button @click="refreshSession">Yes, Keep Me Logged In</av-button>
      </div>
    </av-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import SessionService from './common/sessionService'
import Header from './components/Navigation.vue'
const gracePeriod = 60000

export default defineComponent({
  name: 'App',

  data () {
    return {
      warningTimer: null as unknown as number,
      finalTimer: null as unknown as number,
      showExpirationWarning: false,
      timeToSessionExpiration: 0
    }
  },

  computed: {
    ...mapGetters(['sessionExpiration'])
  },

  watch: {
    /**
     * Update the timer whenever the session expiration changes
     */
    sessionExpiration: {
      handler: function (val) {
        if (val) {
          this.startSessionTimer()
        }
      },
      immediate: true
    }
  },

  methods: {
    /**
     * Shows a window to the user with a chance to stay logged in, or logs them out automatically
     * if they do not respond
     */
    beginFinalTimer (sessionExpiration: number) {
      this.showExpirationWarning = true

      this.finalTimer = setInterval(() => {
        this.timeToSessionExpiration = Math.round((sessionExpiration - Date.now()) / 1000)
        if (this.timeToSessionExpiration <= 0) {
          this.clearTimers()
          SessionService.logOut()
        }
      }, 500)
    },

    /**
     * Clears any current timers
     */
    clearTimers () {
      this.showExpirationWarning = false
      clearInterval(this.finalTimer)
      clearTimeout(this.warningTimer)
      this.finalTimer = 0
      this.warningTimer = 0
    },

    /**
     * Logs the user out
     */
    logOut () {
      SessionService.logOut()
    },

    /**
     * Keeps the user logged in
     */
    refreshSession () {
      SessionService.initializeSession()
    },

    /**
     * Begins a timer to show the user a warning before they are automatically logged out
     */
    startSessionTimer () {
      this.clearTimers()

      const timetoExpiration = this.sessionExpiration - Date.now()

      if (timetoExpiration >= gracePeriod) {
        this.warningTimer = setTimeout(() => {
          this.beginFinalTimer(this.sessionExpiration)
        }, timetoExpiration - gracePeriod)
      } else {
        this.beginFinalTimer(this.sessionExpiration)
      }
    }
  },

  components: {
    navHeader: Header
  }
})
</script>

<style lang="scss">
.slide-enter-active,
.slide-leave-active {
  will-change: opacity transform;
  transition-duration: .2s;
  transition-property: opacity transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
}

.slide-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
</style>
